import { Component, OnInit, Inject } from "@angular/core";
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { locale as english } from './i18n/en';
import { locale as dutch } from './i18n/nl';
import { AppConfig } from '../../../core/configs/app-config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute  } from '@angular/router';
import {UserService } from "../../../core/services/user.service";

@Component({
    selector   : 'medewerkers/bewerken',
    templateUrl: './mdwbewerken.component.html',
    styleUrls  : ['./mdwbewerken.component.scss']
})



export class mdwBewerkenComponent implements OnInit
{
    config: any;
    medewerkerid: number;
    voornaamvalue: string;
    achternaamvalue: string;
    emailvalue: string;
    mobielprivevalue: string;
    mobielwerkvalue: string;
    geboortedatumvalue: Date;
    tvtstartvalue: number;
    vakantiestartuurvalue: number;
    contractuurvalue: number;
    nettouurtariefvalue: number;
    inhuurkrachttariefvalue: number;
    inplanbaarvalue: boolean;
    dienstverbandvalue: number;
    invastedienstvalue: number;
    inhuurvalue: number;
    /**
     * Constructor
     *
     * @param {FuseTranslationLoaderService} _fuseTranslationLoaderService
     */
    
    constructor(private route: ActivatedRoute, private _fuseTranslationLoaderService: FuseTranslationLoaderService, private userService: UserService, @Inject(HttpClient) private http?: HttpClient)
    {
        this.config = {
            "SERVERPROTOCOL": AppConfig.ApiProtocol,
            "SERVERURL": AppConfig.ApiLoginHost,
            "SERVERPORT": AppConfig.ApiPort,
            "APPLICATIONID": AppConfig.ApiApplicationId,            
            "METHOD": AppConfig.ApiMethod,
            "LOGINURL": AppConfig.ApiLoginUrl,
            "STACKURL": AppConfig.ApiUrl
          };
        this._fuseTranslationLoaderService.loadTranslations(english, dutch);

    }

    ngOnInit(): void {
      console.log("JAG");
      this.route.params.subscribe(params => {
        // for example extract the id..
        this.medewerkerid = +params['medewerkerid']; // (+) converts string 'id' to a number
        console.log(this.medewerkerid);
      });

      
  
      let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/employees/overview/" + this.medewerkerid;
      console.log(conString);
        var get = this.http.get(conString);
        get.subscribe(     
        (results:any) => {
          console.log("test");
        for (var result of  results){ 
          console.log(result);
          this.voornaamvalue = result["Voornaam"];
          this.achternaamvalue = result["Achternaam"];
          this.emailvalue = result["Email"];
          this.mobielprivevalue = result["MobielPrive"];
          this.mobielwerkvalue = result["MobielWerk"];
          this.geboortedatumvalue = result["Geboortedatum"];
          this.tvtstartvalue = result["TvtStart"];
          this.vakantiestartuurvalue = result["VakantieStartUur"];
          this.contractuurvalue = result["ContractUur"];
          this.nettouurtariefvalue = result["NettoUurTarief"];
          this.inhuurkrachttariefvalue = result["InhuurKrachtTarief"];
          this.inplanbaarvalue = result["Inplanbaar"];
          if (result["InVasteDienst"] == true){
            this.dienstverbandvalue = 1;
          } else if (result["Inhuur"] == true){
            this.dienstverbandvalue = 2;
          } else {
            this.dienstverbandvalue = 0;
          }

        }  
        },
        (error) => {
        console.error(error);
        });

    }

    getRecord(medewerkerid){
        console.log(medewerkerid);
    }

    saveMedewerker(){
      if (this.dienstverbandvalue == 0) {
        this.invastedienstvalue = 1
        this.inhuurvalue = 0
      } else if (this.invastedienstvalue == 1) {
        this.invastedienstvalue = 0
        this.inhuurvalue = 1
      } else {
        this.invastedienstvalue = 0
        this.inhuurvalue = 0
      }
      var body = {
        "MedewerkerID": this.medewerkerid,
        "Achternaam":  this.achternaamvalue,
        "Voornaam": this.voornaamvalue,
        "CplNaam": this.voornaamvalue + " " + this.achternaamvalue,
        "Email": this.emailvalue,
        "GeboorteDatum": this.geboortedatumvalue,
        "Inplanbaar": this.inplanbaarvalue,
        "MobielPrive": this.mobielprivevalue,
        "MobielWerk": this.mobielwerkvalue,
        "TvtStart": this.tvtstartvalue,
        "VakantieStartUur": this.vakantiestartuurvalue,
        "ContractUur": this.contractuurvalue,
        "NettoUurTarief": this.nettouurtariefvalue,
        "InhuurKrachtTarief": this.inhuurkrachttariefvalue,
        "InVasteDienst": this.invastedienstvalue,
        "Inhuur": this.inhuurvalue,
       };
 
     let conString = this.config.SERVERPROTOCOL + this.config.SERVERURL + this.config.SERVERPORT + "/api/employees/edit/";
       var post = this.http.post(conString,body);
       post.subscribe(     
       (results) => {
        console.log(results);
       },
       (error) => {
       console.error(error);
       });

    }
      
}
